/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FirstName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function FirstName({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Details/FirstName",
  isInvalid,
  onChange
  
}) {
  let isMedia = useIsMedia()
let profilePatientPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'person.first_name',
})
let profilePatientPersonFirstNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'profile_patient',
path: 'person.first_name',
validate: fromValidate.name,
required: true,
})
let profilePatientPersonFirstNameChangeData = fromData.useDataChange({ viewPath,
context: 'profile_patient',
path: 'person.first_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="profile_patient.person.first_name"
 validate="/Data/validate.js name"
 required={true}
 invalid={!profilePatientPersonFirstNameIsValidData}
 value={profilePatientPersonFirstNameValueData}
 onChange={profilePatientPersonFirstNameChangeData}
 size={isMedia.mobile ? "small" : "medium"}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="First name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 tabIndex={2}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}